module.exports = __webpack_public_path__ + "static/media/api.2278b687.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/api.svg
// module id = 1046
// module chunks = 3